<template>
	<!--download href="`${filePath}`"-->
	<a class="export-card" @click="downloadImage()">
		<span class="export-card-image"
			><font-awesome-icon :icon="[iconWeight, icon]"
		/></span>
		<span class="export-card-type">{{ cardText }}</span>
	</a>
</template>

<script>
import * as htmlToImage from 'html-to-image';
import download from 'downloadjs';
import { mapActions, mapState } from 'vuex';
import { ERROR_DETAILS } from '@/constants/error-details';

export default {
	name: 'ExportCard',
	props: {
		icon: String,
		iconWeight: String,
		cardText: String,
		exportType: String,
		filePath: String,
	},
	computed: mapState({
		selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
		selectedImage: (state) => state.brandBuilderEditor.selectedImage,
		selectedDesign: (state) => state.brandBuilderEditor.selectedDesign,
		state: (state) => state,
	}),
	methods: {
		...mapActions(['toggleLoader', 'showErrorModal']),
		uploadFile(file) {
			const url = 'https://api.cloudinary.com/v1_1/uwm/upload';
			const xhr = new XMLHttpRequest();
			const fd = new FormData();
			xhr.open('POST', url, true);
			xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

			// reset the upload progress bar
			// document.getElementById('progress').style.width = 0;

			// Update progress (can be used to show progress indicator)
			xhr.upload.addEventListener('progress', () => {
				// var progress = Math.round((e.loaded * 100.0) / e.total);
				// document.getElementById('progress').style.width = progress + "%";
			});

			xhr.onreadystatechange = function stateChange() {
				if (xhr.readyState === 4 && xhr.status === 200) {
					// File uploaded successfully
					const response = JSON.parse(xhr.responseText);
					download(
						`https://res.cloudinary.com/uwm/video/upload/eo_10,o_50,l_${response.public_id.replace(
							'/',
							':',
						)},so_0/v1566662844/videos/missworld.mp4`,
						'my-video.mp4',
					);
				}
			};

			fd.append('upload_preset', 'jlw-test');
			fd.append('tags', 'browser_upload'); // Optional - add tag for image admin in Cloudinary
			fd.append('file', file);
			xhr.send(fd);
		},
		createPDF(file) {
			// upload to cloudinary for pdf conversion
			const that = this;
			const url = 'https://api.cloudinary.com/v1_1/uwm/upload';
			const xhr = new XMLHttpRequest();
			const fd = new FormData();
			xhr.open('POST', url, true);
			xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

			fd.append('upload_preset', 'temporary-pdf');
			fd.append('tags', 'temp-pdf');
			fd.append('file', file);
			xhr.send(fd);

			xhr.onreadystatechange = function stateChange() {
				if (xhr.readyState === 4 && xhr.status === 200) {
					// File uploaded successfully
					const response = JSON.parse(xhr.responseText);
					that.downloadPDF(response);
					document
						.getElementById('item-container')
						.classList.remove('fullscale');
				}
			};
		},
		downloadPDF(cloudinaryObject) {
			// download from cloudinary as pdf
			const that = this;
			const PDFUrl = cloudinaryObject.secure_url.replace('.jpg', '.pdf');
			const fileName = `${this.getFileName()}.pdf`;
			const xhr = new XMLHttpRequest();

			xhr.open('GET', PDFUrl, true);
			xhr.responseType = 'arraybuffer';
			xhr.onload = function loader() {
				if (this.status === 200) {
					const blob = new Blob([this.response], {
						type: 'application/pdf',
					});
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = fileName;
					link.click();
					that.deleteTempImage(cloudinaryObject.delete_token);
				}
			};
			xhr.send();
		},
		deleteTempImage(token) {
			// todo: put in a service
			fetch('https://api.cloudinary.com/v1_1/uwm/delete_by_token', {
				body: `token=${token}`,
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				method: 'POST',
			});
		},
		getFileName() {
			const type = this.selectedMediaType;
			const mediaTypes = {
				1: 'flyer',
				2: 'social-banner',
				3: 'video',
				4: 'presentation',
				6: 'pricing',
			};
			if (mediaTypes[type]) {
				return `my-${mediaTypes[type]}`;
			} else {
				return `my-flyer`;
			}
		},
		downloadImage() {
			if (this.exportType === 'email') {
				return;
			}
			// Only allow the loader and scaling of the template if the export type is not email.
			if (this.exportType !== 'email') {
				this.toggleLoader();
				// This allows the Title card scale to be a scale of 1 instead of the viewport size.
				document.getElementById('item-container').classList.add('fullscale');
			}

			// create the target item for the scale check
			const targetScale = document.getElementById('item-container');
			// Set the target check to an interval
			// TODO: refactor so function is scaleTemplateCheck declared before called
			// eslint-disable-next-line no-use-before-define
			const interval = setInterval(scaleTemplateCheck, 250);

			const fileName = this.getFileName();
			const that = this;

			function scaleTemplateCheck() {
				// This gets the current scale of the title card.
				const compStyle = window.getComputedStyle(targetScale);
				const transformValue = compStyle.getPropertyValue('transform');

				// If the interval does not produce the scale of 1 result redo the interval and once the scale of 1 is confirmed proceed to the htmlToImage checks
				if (transformValue !== 'matrix(1, 0, 0, 1, 0, 0)') {
					return;
				}
				clearInterval(interval);

				// Checks the scale for the various export types
				if (that.exportType === '.PNG') {
					htmlToImage
						.toPng(document.getElementById('item-container'), {
							backgroundColor: '#fff',
							quality: 1,
							pixelRatio: 1,
						})
						.then((dataUrl) => {
							download(dataUrl, `${fileName}.png`);
							if (that.selectedMediaType !== 2) {
								// This allows the Title card scale to be a scale of 1 instead of the viewport size.
								document
									.getElementById('item-container')
									.classList.remove('fullscale');
							}
							that.toggleLoader();
						});
				} else if (that.exportType === '.JPG') {
					htmlToImage
						.toJpeg(document.getElementById('item-container'), {
							backgroundColor: '#fff',
							quality: 1,
							pixelRatio: 1,
						})
						.then((dataUrl) => {
							download(dataUrl, `${fileName}.jpg`);
							if (that.selectedMediaType !== 2) {
								document
									.getElementById('item-container')
									.classList.remove('fullscale');
							}
							that.toggleLoader();
						});
				} else if (that.exportType === '.mp4') {
					htmlToImage
						.toPng(document.getElementById('item-container'), {
							backgroundColor: '#fff',
							quality: 1,
							pixelRatio: 1,
						})
						.then((dataUrl) => {
							that.uploadFile(dataUrl);
						});
				} else if (that.exportType === '.PDF') {
					htmlToImage
						.toJpeg(document.getElementById('item-container'), {
							backgroundColor: '#fff',
							quality: 1,
							pixelRatio: 1,
						})
						.then((image) => {
							that.createPDF(image);
							that.toggleLoader();
						});
				} else if (that.exportType === 'print') {
					const item = document.getElementById('item-container');
					htmlToImage
						.toJpeg(item, {
							backgroundColor: '#fff',
							pixelRatio: 1,
						})
						.then((dataUrl) => {
							function VoucherSourcetoPrint(source) {
								return `
									<html>
										<head>
											<script>
												function printAndClose() {
													setTimeout(()=>{
														window.print();
														window.close();
													}, 10)
												}
											<\/script>
										</head>
										<body onload='printAndClose()'>
											<img src='${source}' style='max-width:100%'/>
										</body>
									</html>
								`;
							}
							function removeFullScale() {
								if (that.selectedMediaType !== 2) {
									item.classList.remove('fullscale');
								}
							}
							const pagelink = 'about:blank';
							const printPage = window.open(pagelink, '_new');
							if (!printPage) {
								removeFullScale();
								that.toggleLoader();
								that.showErrorModal({
									error: 'Pop-up Blocking is Active',
									errorDetails: {
										...ERROR_DETAILS.POPUP_BLOCKER,
										message:
											'Unable to Print This Flyer.  If you have a pop-up blocker please turn it off temporarily and try again. If the issue continues, please reach out to your Account Executive.',
									},
								});
							} else {
								printPage.document.open();
								printPage.document.write(VoucherSourcetoPrint(dataUrl));
								printPage.document.close();
								removeFullScale();
								that.toggleLoader();
							}
						});
				} else if (that.exportType === 'Download') {
					// TODO: Determine if there is a situation where this is being used.
					window.open(that.selectedDesign.item.medias[0].uri);
				}
			} // end of if statement
		},
	},
};
</script>

<style lang="scss" scoped>
.export-card {
	@include rem('padding', 9px 15px);
	display: flex;
	align-items: center;
	background-color: $off-white;
	border-radius: $b360-border-radius-base;
	border: $b360-border-width-thin $border-color-light solid;
	text-decoration: none;
	box-shadow: none;
	transition: $b360-motion-selection;
	cursor: pointer;

	&:hover {
		border-color: $b360-color--gray__medium;
		box-shadow: 0 0 6px $shadow-color;
	}

	&.disabled {
		cursor: not-allowed;
		background: $b360-color--gray__light;

		> span {
			color: $b360-color--gray__medium-plus;
		}

		&:hover {
			border: $b360-border-width-thin $border-color-light solid;
			box-shadow: unset;
		}
	}
}

.export-card-image {
	@include rem('font-size', 26px);
	@include rem('margin-right', 16px);
	color: $brand-teal;
}

.export-card-type {
	font-size: $b360-font-size--base;
	color: $text-base-color;
	font-weight: 500;
}
</style>
